/*
    Component provides scroll view visible rectangle area for rendering optimization
*/

import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { debounceTime } from 'rxjs/operators';

import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RxIconModule } from '../rx-icon/rx-icon.module';
import { ScrollBarService } from '@nrwl/scrollbar-service';
import { RxScrollableComponent } from '@org/design-system';

@Component({
  selector: 'rx-accordion',
  templateUrl: './rx-accordion.component.html',
  styleUrls: ['./rx-accordion.component.scss'],
  imports: [CommonModule, FormsModule, RxIconModule, RxScrollableComponent],
})
export class RxAccordionComponent implements OnInit, OnDestroy, AfterViewChecked {
  public toolbarHeight = 0;
  private _scrollEvent = new Subject<any>();

  @Input()
  public loadingMore = false;

  @Output()
  public psReachEnd = new EventEmitter<number>();
  public ready;
  @ViewChild('toolbarWrapper', { static: true }) toolbarWrapper: ElementRef;
  @ViewChild('overlay') overlayRef: ElementRef;
  @HostBinding('attr.data-element-id') UID = 'uid' + Math.random().toString(36).substring(2);

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    this._scrollEvent.next($event);
  }

  constructor(
    private ref: ChangeDetectorRef,
    private elementRef: ElementRef,
    private scrollService: ScrollBarService,
  ) {
    // Reference for rx-list-item through service to optimize displaying large result set
    this._scrollEvent.pipe(debounceTime(100)).subscribe(($event) => {
      const rect = this.elementRef.nativeElement.getBoundingClientRect();
      // this.scrollService.notify($event, this.UID, rect);
    });
  }

  ngOnInit() {
    // Triggering window resize event fixes rx-list-item optimization
    window.dispatchEvent(new Event('resize'));
  }
  onScrollNearEnd() {
    this.psReachEnd.emit();
  }

  ngAfterViewChecked() {
    if (this.toolbarWrapper) {
      const height = this.toolbarWrapper.nativeElement.offsetHeight;
      if (this.toolbarHeight !== height) {
        this.toolbarHeight = height;
        this.ref.detectChanges();
      }
    }
    //this.perfectScroll.directiveRef.config.suppressScrollY = false;
    //this.perfectScroll.directiveRef.update();
  }

  onScrollYEvent($event) {
    this._scrollEvent.next($event);
  }

  // psYReachEndEvent($event) {
  //     this._scrollEvent.next($event);
  //     this.psReachEnd.emit();
  // }

  ngOnDestroy(): void {}
}
